import { useEffect, useState } from "react";
import { getPlayerStats } from "@/lib/api";

export default function Stats() {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getPlayerStats().then(setStats).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 py-10" data-testid="stats-page">
      <p className="text-xs uppercase tracking-[0.3em] text-primary font-bold">Career</p>
      <h1 className="font-display font-black uppercase text-4xl sm:text-5xl tracking-tight mt-2 mb-8">
        Player Stats
      </h1>

      {loading ? (
        <p className="text-muted-foreground uppercase tracking-[0.3em] text-xs">Loading...</p>
      ) : stats.length === 0 ? (
        <div className="border border-dashed border-border p-12 text-center text-muted-foreground uppercase text-xs tracking-[0.2em]">
          No player data yet
        </div>
      ) : (
        <div className="border border-border bg-card overflow-x-auto">
          <table className="w-full text-sm min-w-[800px]">
            <thead className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
              <tr>
                <th className="text-left px-5 py-3 font-bold">Player</th>
                <th className="text-right px-3 py-3 font-bold">M</th>
                <th className="text-right px-3 py-3 font-bold">Inn</th>
                <th className="text-right px-3 py-3 font-bold">Runs</th>
                <th className="text-right px-3 py-3 font-bold">HS</th>
                <th className="text-right px-3 py-3 font-bold">Avg</th>
                <th className="text-right px-3 py-3 font-bold">SR</th>
                <th className="text-right px-3 py-3 font-bold">4s</th>
                <th className="text-right px-3 py-3 font-bold">6s</th>
                <th className="text-right px-3 py-3 font-bold">Wkts</th>
                <th className="text-right px-5 py-3 font-bold">Eco</th>
              </tr>
            </thead>
            <tbody>
              {stats.map((s, i) => (
                <tr key={s.name} className={`${i % 2 === 0 ? "bg-card" : "bg-[#0F1410]"} border-t border-border`}>
                  <td className="px-5 py-2.5 font-display uppercase font-bold tracking-tight">{s.name}</td>
                  <td className="px-3 py-2.5 text-right font-mono stat-tabular">{s.matches}</td>
                  <td className="px-3 py-2.5 text-right font-mono stat-tabular">{s.innings_batted}</td>
                  <td className="px-3 py-2.5 text-right font-mono stat-tabular text-primary font-bold">{s.runs}</td>
                  <td className="px-3 py-2.5 text-right font-mono stat-tabular">{s.highest_score}</td>
                  <td className="px-3 py-2.5 text-right font-mono stat-tabular">{s.batting_avg}</td>
                  <td className="px-3 py-2.5 text-right font-mono stat-tabular">{s.strike_rate}</td>
                  <td className="px-3 py-2.5 text-right font-mono stat-tabular">{s.fours}</td>
                  <td className="px-3 py-2.5 text-right font-mono stat-tabular">{s.sixes}</td>
                  <td className="px-3 py-2.5 text-right font-mono stat-tabular text-primary font-bold">{s.wickets}</td>
                  <td className="px-5 py-2.5 text-right font-mono stat-tabular">{s.economy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
